import AWS from "aws-sdk";
import toast from "react-hot-toast";
import { Buffer } from "buffer";
import { isDev } from "../utils/getApiUrl";

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_INVOICE_accessKeyId,
  secretAccessKey: process.env.REACT_APP_INVOICE_secretAccessKey,
  region: process.env.REACT_APP_INVOICE_region,
});

export const uploadWarrantyCardToS3 = async (
  mobileNumber: string,
  base64Data: string,
  fileName: string,
  ContentType: string
): Promise<{ success: boolean; url?: string }> => {
  try {
    const buffer = Buffer.from(base64Data, "base64");

    const key = `warranty/${Date.now()}_${fileName}`;
    let bucketName = "";

    if (isDev) {
      if (!process.env.REACT_APP_WhatsApp_Bulk_S3_DEV) {
        throw new Error(
          "S3 Bucket name is not defined in environment variables."
        );
      }
      bucketName = process.env.REACT_APP_WhatsApp_Bulk_S3_DEV;
    } else {
      if (!process.env.REACT_APP_WhatsApp_Bulk_S3) {
        throw new Error("Bucket name is not defined in environment variables.");
      }
      bucketName = process.env.REACT_APP_WhatsApp_Bulk_S3;
    }

    const uploadParams = {
      Bucket: bucketName,
      Key: key,
      Body: buffer,
      ContentType,
      ACL: "public-read",
    };

    await s3.upload(uploadParams).promise();

    const generatePresignedUrl = async (fileKey: string): Promise<string> => {
      const params = {
        Bucket: bucketName,
        Key: fileKey,
        Expires: 60,
      };
      return s3.getSignedUrlPromise("getObject", params);
    };

    const presignedUrl = await generatePresignedUrl(key);

    return { success: true, url: presignedUrl };
  } catch (error) {
    console.error("S3 Upload Error:", error);
    toast.error("Failed to upload warranty card.");
  }
  return { success: false };
};
